import { ValidationStates } from '@opengov/component-library';
import { createSelector, Selector } from 'reselect';

import { ReportTypes } from './reportTypes';

const cleanString = (aString) => aString.trim();

const checkForm = (title) => {
  const cleanTitle = cleanString(title);
  return {
    validationState: cleanTitle.length === 0 ? ValidationStates.Error : ValidationStates.Success,
    cleanTitle: cleanTitle
  };
};

const updateState = (state, key, title, formValidationState) => {
  return state
    .update(key, (report) => report.set('title', title))
    .update('titleState', (_validationState) => formValidationState)
    .update('formState', (_validationState) => formValidationState);
};

export const reportFormActions = (compose, key) => {
  return {
    updateReportTitle: compose.action((state, dirtyTitle: string) => {
      const { validationState } = checkForm(dirtyTitle);
      return updateState(state, key, dirtyTitle, validationState);
    }),

    blurReportTitle: compose.action((state, dirtyTitle: string) => {
      const { cleanTitle, validationState } = checkForm(dirtyTitle);
      return updateState(state, key, cleanTitle, validationState);
    }),

    updateReportType: compose.action((state, type: ReportTypes) => {
      return state.set('typeState', type);
    }),

    updateReportDescription: compose.action((state, reportDescription: string) => {
      return state.update(key, (report) => report.set('description', reportDescription));
    }),

    blurReportDescription: compose.action((state, reportDescription: string) => {
      const cleanDescription = cleanString(reportDescription);
      return state.update(key, (report) => report.set('description', cleanDescription));
    })
  };
};

export const reportFormSelectors = (source: Selector<any, any>) => {
  return {
    selectReportFormDescriptionValidationState: createSelector(
      [source],
      (reportCreateState) => reportCreateState.descriptionState
    ),

    selectReportFormTitleValidationState: createSelector([source], (reportCreateState) => reportCreateState.titleState),

    selectReportFormValidationState: createSelector([source], (reportCreateState) => reportCreateState.formState),

    selectReportFormTypeState: createSelector([source], (reportCreateState) => reportCreateState.typeState)
  };
};
